import name from './name'

const selectSliceData = state => state[name]

const selectAnnouncements = state => selectSliceData(state).items
const selectTotal = state => selectSliceData(state).total
const selectLoading = state => selectSliceData(state).loading
const selectLoadingMore = state => selectSliceData(state).loadingMore
const selectError = state => selectSliceData(state).error
const selectHasLoaded = state => selectSliceData(state).hasLoaded

/** More pages exist only once the first one has answered with a `total`. */
const selectHasMore = state => {
  const { items, total, hasLoaded } = selectSliceData(state)
  return hasLoaded && items.length < total
}

/**
 * Newest `publishedAt` in the loaded list — what the nav "NEW" badge and the
 * home rail key off. The list is reverse-chron from the server, but a max is
 * cheap insurance against a page that isn't.
 */
const selectLatestPublishedAt = state => {
  return selectAnnouncements(state).reduce((latest, item) => {
    if (!item?.publishedAt) return latest
    return !latest || item.publishedAt > latest ? item.publishedAt : latest
  }, null)
}

const selectCurrent = state => selectSliceData(state).current
const selectCurrentLoading = state => selectSliceData(state).currentLoading
const selectCurrentError = state => selectSliceData(state).currentError

export {
  selectAnnouncements,
  selectTotal,
  selectLoading,
  selectLoadingMore,
  selectError,
  selectHasLoaded,
  selectHasMore,
  selectLatestPublishedAt,
  selectCurrent,
  selectCurrentLoading,
  selectCurrentError
}
